<template>
    <CalcCard
        step="§calc.step1.eyebrow"
        title="§calc.step1.title"
        subtitle="§calc.step1.subtitle"
    >
        <p v-if="showNotice" class="calc-step1-notice">{{ $t('§calc.step4.notice') }}</p>

        <div class="calc-form-grid">
            <CalcField label="§calc.step1.fields.amount">
                <template #info>
                    <CalcTooltip>
                        {{ $t('§calc.step1.fields.amount_tooltip') }}
                    </CalcTooltip>
                </template>

                <CalcNumberInput
                    :model-value="data.amount"
                    placeholder="§calc.step1.fields.amount_placeholder"
                    :invalid="!!errors.amount"
                    @update:model-value="emitField('amount', $event)"
                />
            </CalcField>

            <CalcField label="§calc.step1.fields.lending">
                <template #info>
                    <CalcTooltip>
                        {{ $t('§calc.step1.fields.lending_tooltip') }}
                    </CalcTooltip>
                </template>

                <CalcDropdown
                    :model-value="data.lending"
                    :options="lendingOptions"
                    placeholder="§calc.placeholders.select_one"
                    :invalid="!!errors.lending"
                    @update:model-value="emitField('lending', $event)"
                />
            </CalcField>

            <CalcField label="§calc.step1.fields.utilization">
                <template #info>
                    <CalcTooltip>
                        {{ $t('§calc.step1.fields.utilization_tooltip') }}
                    </CalcTooltip>
                </template>

                <CalcNumberInput
                    :model-value="data.utilization"
                    mode="decimal"
                    placeholder="§calc.step1.fields.utilization_placeholder"
                    :invalid="!!errors.utilization"
                    @update:model-value="emitField('utilization', $event)"
                />
            </CalcField>

            <CalcField label="§calc.step1.fields.billing">
                <template #info>
                    <CalcTooltip>
                        {{ $t('§calc.step1.fields.billing_tooltip') }}
                    </CalcTooltip>
                </template>

                <CalcDropdown
                    :model-value="data.billing"
                    :options="billingOptions"
                    placeholder="§calc.placeholders.select_one"
                    :invalid="!!errors.billing"
                    @update:model-value="emitField('billing', $event)"
                />
            </CalcField>
        </div>

        <div class="calc-btn-row calc-btn-row--end">
            <CalcButton
                variant="primary"
                label="§calc.step1.cta.continue"
                icon-name="arrow-right"
                icon-color="white"
                @click="$emit('next')"
            />
        </div>
    </CalcCard>
</template>

<script>
import CalcCard from '../components/CalcCard.vue'
import CalcField from '../components/CalcField.vue'
import CalcNumberInput from '../components/CalcNumberInput.vue'
import CalcDropdown from '../components/CalcDropdown.vue'
import CalcTooltip from '../components/CalcTooltip.vue'
import CalcButton from '../components/CalcButton.vue'
import { BILLING_DROPDOWN_OPTIONS } from '../data/billingUnits.js'
import { LENDING_DROPDOWN_OPTIONS } from '../data/lendingTerms.js'

export default {
    name: 'CalcStep1',

    components: {
        CalcCard,
        CalcField,
        CalcNumberInput,
        CalcDropdown,
        CalcTooltip,
        CalcButton,
    },

    props: {
        data: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        showNotice: {
            type: Boolean,
            default: false,
        },
    },

    emits: ['update:data', 'next'],

    computed: {
        lendingOptions() {
            return LENDING_DROPDOWN_OPTIONS
        },

        billingOptions() {
            return BILLING_DROPDOWN_OPTIONS
        },
    },

    methods: {
        emitField(name, value) {
            this.$emit('update:data', { [name]: value })
        },
    },
}
</script>

<style scoped>
.calc-step1-notice {
    margin: 0 0 28px;
    font-size: 16px;
    line-height: 1.5;
    color: var(--calc-ink);
    background: var(--calc-green-mint);
    border-radius: 12px;
    padding: 18px 22px;
}
</style>
